import { render, staticRenderFns } from "./cModalWsp.vue?vue&type=template&id=ee4ac3e6"
import script from "./cModalWsp.vue?vue&type=script&lang=js"
export * from "./cModalWsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports